<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
				<div class="col-md-12">
          <h3 v-if="resourcepool.name">{{ resourcepool.name }}</h3>
          <h3 v-else>{{ _('New Resource') }}</h3>
        </div>
      </div>
      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition-group name="fade">
          <div v-bind="tabPanel('general')" class="tab-pane active" id="general" v-if="isTabActive('general')" key="general">
            <div class="row">
              <div class="col-lg-6 col-sm-8 leftcol">
                <h3>{{ _('General') }}</h3>
                <div class="form-group languageversioned">
                  <label for="name">{{ _('Name') }}</label>
                  <input id="name" class="form-control" name="name" type="text" v-model="resourcepool.name" />
                </div>
                <div class="form-group languageversioned">
                  <label for="description">{{ _('Description') }}</label>
                  <textarea id="description" class="form-control" name="description" rows="8" wrap="virtual" v-model="resourcepool.description"></textarea>
                </div>
                <div class="checkbox">
                  <label>
                  <input type="checkbox" name="hidden" v-model="resourcepool.hidden" true-value="1" false-value="0" />
                  {{ _('Hide from timeline view') }}
                  </label>
                </div>
              </div>
              <div class="col-lg-6 col-sm-4 rightcol">
                <div id="resourcepoolProducts">
                  <div class="list-group">
                    <h3 v-if="resourcepool.sharedProduct && resourcepool.sharedProduct.length">{{ _('Products that use this resource pool') }}</h3>
                    <a class="list-group-item prodLink" href="javascript:;" v-for="prod in resourcepool.sharedProduct">{{ prod.name }}</a>
                    <div v-if="resourcepool.sharedProduct && resourcepool.sharedProduct.length">
                      <br>
                      <p>{{ _('If you wish to remove this resource pool from a product that has multiple sources of availabilility, edit the availability of the product in question and use the \'Remove from this product\' link next to this resource pool.') }}</p>
                    </div>
                    <p v-else>{{ _('The resource pool is not directly attached to any products.') }}</p>
                  </div>
                </div>
                <p></p>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('resourcepools')" class="tab-pane active" id="resourcepools" v-if="isTopLevelResourcepool && isTabActive('resourcepools')" key="resourcepools">
            <div class="row">
              <div class="col-lg-6 col-sm-6 leftcol">
                <div class="form-group">
                  <h3>{{ _('Resource pools') }}</h3>
                  <table class="table table-striped sortable" v-if="resourcepool.sharedResourcepool && resourcepool.sharedResourcepool.length">
                    <thead>
                      <tr>
                        <th>{{ _('Name') }}</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <draggable v-model="resourcepool.sharedResourcepool" tag="tbody" draggable=".resourcepool" :delay="100" :delayOnTouchOnly="true">
                      <tr class="resourcepool" v-for="pool in resourcepool.sharedResourcepool">
                        <td class="sortable">{{ pool.name }}</td>
                        <td><a href="javascript:;" class="pull-right" v-on:click="removeResourcepool(pool)"><i class="fa fa-fw fa-close"></i></a></td>
                      </tr>
                    </draggable>
                  </table>
                  <p v-else>{{ _('There are no resource pools linked to this resource pool.') }}</p>
                  <button type="button" class="btn btn-info" id="addResourcepool" v-on:click="selectResourcepools"><i class="fa fa-fw fa-sitemap"></i> {{ _('Attach resource pool') }}</button>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('resources')" class="tab-pane active" id="resources" v-if="isTabActive('resources')" key="resources">
            <div class="row">
              <div class="col-lg-6 col-sm-6 leftcol">
                <div class="form-group">
                  <h3>{{ _('Resources') }}</h3>
                  <h4>{{ _('Resources in the pool') }}</h4>
                  <table class="table table-striped sortable" v-if="resourcepool.sharedResource && resourcepool.sharedResource.length">
                    <thead>
                      <tr>
                        <th>{{ _('Name') }}</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <draggable v-model="resourcepool.sharedResource" tag="tbody" draggable=".resource" :delay="100" :delayOnTouchOnly="true">
                      <tr class="resource" v-for="resource in resourcepool.sharedResource">
                        <td class="sortable">{{ resource.name }}</td>
                        <td><a href="javascript:;" class="pull-right" v-on:click="removeResource(resource)"><i class="fa fa-fw fa-close"></i></a></td>
                      </tr>
                    </draggable>
                  </table>
                  <p v-else>{{ _('There are no resources in this resource pool.') }}</p>
                  <button type="button" class="btn btn-info" id="addResource" v-on:click="selectResources"><i class="fa fa-fw fa-cube"></i> {{ _('Attach resource') }}</button>
                </div>
              </div>
              <div class="col-lg-6 col-sm-6 rightcol">
                <div class="form-group">
                  <h3>{{ _('Allocation strategy') }}</h3>
                  <select class="form-control" v-model="selectable">
                    <option value="0">{{ _('Use automatic resource selection') }}</option>
                    <option value="1">{{ _('Allow users to select the number of resources') }}</option>
                    <option value="2">{{ _('Allow users to select the resources') }}</option>
                  </select>
                  <br/>
                  <template v-if="isResourceAllocationVisible">
                    <label for="allocationStrategy">{{ _('Resource allocation') }}</label>
                    <select class="form-control" name="allocation" id="allocationStrategy" v-model="allocation">
                      <option class="" value="random">{{ _('Random') }} - {{ _('Allocate resources in random order') }}</option>
                      <option v-if="isBestFitAllocationSelectable" value="bestfit">{{ _('Best fit') }} - {{ _('Allocate resources with optimal capacity') }}</option>
                      <option class="" value="priority">{{ _('Prioritized') }} - {{ _('Allocate resources in a predefined order') }}</option>
                      <option v-if="isAllResourcesAllocationSelectable" value="spread">{{ _('Spread') }} - {{ _('Attempt to allocate a resource for each seat') }}</option>
                      <option v-if="isAllResourcesAllocationSelectable" value="all">{{ _('All') }} - {{ _('Allocate all available resources') }}</option>
                    </select>
                    <br />
                  </template>
                  <label for="seatAllocationStrategy">{{ _('Seat allocation') }}</label>
                  <select class="form-control" name="seatallocation" id="seatAllocationStrategy" v-model="seatAllocation">
                    <option value="fill" v-if="isSeatAllocationSelectable">{{ _('Fill') }} - {{ _('Allocate all available seats in one resource before adding another one') }}</option>
                    <option value="balance">{{ _('Balance') }} - {{ _('Distribute seats evenly across allocated resources') }}</option>
                    <option value="single" v-if="isSeatAllocationSelectable">{{ _('Single') }} - {{ _('Only use one resource from the pool') }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <nav class="save-bar">
      <div class="flex-row space-between">
        <button class="btn btn-danger" v-on:click="remove(_('Are you sure you want to delete the resource pool? The resource pool will be completely removed from the system and the deletion can\'t be undone.'))" type="button" :disabled="!isRemoveButtonEnabled"><i class="fa fa-fw fa-trash"></i><span class="hidden-xs"> {{ _('Delete resource pool') }}</span></button>
        <div class="button-col">
          <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
          <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i><span class="hidden-xs"> {{ _('Close') }}</span></button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import changewatcher from '~/lib/changewatcher'
import settingshelpers from '~/lib/settingshelpers'
import components from '~/lib/components'
import ResourceSelector from '~/components/modals/ResourceSelector'
import ResourcepoolSelector from '~/components/modals/ResourcepoolSelector'

export default {
  data () {
    return {
      resourcepool: {},
      selectedResourcepool: null
    }
  },
  mixins: [changewatcher, components, settingshelpers],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'general', label: this._('General') },
        { id: 'resourcepools', label: this._('Resource pools'), hidden: !(this.isTopLevelResourcepool && this.isFeatureEnabled('packaging')) },
        { id: 'resources', label: this._('Resources') }
      ])
    },
    isTopLevelResourcepool () {
      return this.resourcepool && !parseInt(this.resourcepool.level)
    },
    isNewResourcepool () {
      return !parseInt(this.resourcepool.id)
    },
    isResourceAllocationVisible () {
      if (!this.resourcepool) {
        return true
      }
      if (parseInt(this.resourcepool.selectable) === 2) {
        return false
      }
      return true
    },
    isBestFitAllocationSelectable () {
      if (!this.resourcepool) {
        return true
      }
      if (parseInt(this.resourcepool.selectable)) {
        return false
      }
      return true
    },
    isAllResourcesAllocationSelectable () {
      if (!this.resourcepool) {
        return true
      }
      if (parseInt(this.resourcepool.selectable)) {
        return false
      }
      return true
    },
    isSeatAllocationSelectable () {
      if (!this.resourcepool) {
        return true
      }
      if (parseInt(this.resourcepool.selectable) || this.resourcepool.allocation === 'all' || this.resourcepool.allocation === 'spread') {
        return false
      }
      return true
    },
    selectable: {
      get () {
        if (!this.resourcepool || !this.resourcepool.selectable) {
          return '0'
        }
        return this.resourcepool.selectable
      },
      set (newValue) {
        if (newValue) {
          this.resourcepool.selectable = newValue
        }
      }
    },
    allocation: {
      get () {
        if (!this.resourcepool || !this.resourcepool.allocation) {
          return 'random'
        }
        return this.resourcepool.allocation
      },
      set (newValue) {
        if (newValue) {
          this.resourcepool.allocation = newValue
        }
      }
    },
    seatAllocation: {
      get () {
        if (!this.resourcepool || !this.resourcepool.seatallocation) {
          return 'fill'
        }
        return this.resourcepool.seatallocation
      },
      set (newValue) {
        if (newValue) {
          this.resourcepool.seatallocation = newValue
        }
      }
    },
    isSelectableEnabled () {
      return this.allocation !== 'all'
    }
  },
  methods: {
    getSaveData () {
      const exportFields = [
        'id',
        'name',
        'description',
        'hidden',
        'selectable',
        'allocation',
        'seatallocation',
        'sharedResource',
        'sharedResourcepool'
      ]
      const data = exportFields.reduce((a, e) => (a[e] = this.resourcepool[e], a), {})
      data.source = 'editor'
      data.version = this.version
      return data
    },
    async doRemove () {
      let response
      try {
        this.deleted = true
        response = await axios.delete(this.baseDomain + this.shopId + '/resourcepools/' + this.resourcepool.id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        this.deleted = false
        return this.showError(this._('Deleting the resource pool failed!'))
      }
      this.showNotification(this._('Resource pool deleted!'))
      this.close()
    },
    async save () {
      this.saving = true
      const data = this.getSaveData()
      let response
      try {
        if (data.id) {
          response = await axios.put(this.baseDomain + this.shopId + '/resourcepools/' + data.id + '.json?apikey=' + this.apiKey, data)
        } else {
          delete data.id
          response = await axios.post(this.baseDomain + this.shopId + '/resourcepools.json?apikey=' + this.apiKey, data)
        }
      } catch(e) {
        this.saving = false
        return this.showError(e)
      }
      if (response && response.data && response.data.id) {
        await this.loadResourcepool(response.data.id)
      }
      this.saving = false
      this.saved = true
      this.storeState()
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.resourcepool)
      if (this.saveShouldClose) {
        this.close()
      }
    },
    async reloadOnVersionChange () {
      if (!this.resourcepool || !this.resourcepool.id) {
        return
      }
      await this.loadResourcepool(this.resourcepool.id)
    },
    loadResourcepool (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/resourcepools/' + id + '.json?resources=true&products=true&apikey=' + this.apiKey + this.versionStr)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject()
          return
        }
        this.resourcepool = response.data
        this.storeState()
        this.loading = false
        resolve(this.resourcepool)
      })
    },
    selectResources () {
      this.showModal('resourceselector', ResourceSelector, {
        props: {
          selectedResources: this.resourcepool.sharedResource.map(r => { return { id: r.id } })
        },
        events: {
          selectResources: this.addResources
        },
        handlers: {},
        width: 800
      })
    },
    addResources (resources) {
      if (resources && resources.length) {
        this.resourcepool.sharedResource.push(...resources)
      }
    },
    removeResource(resource) {
      this.resourcepool.sharedResource = this.resourcepool.sharedResource.filter(r => r.id !== resource.id)
    },
    selectResourcepools () {
      this.showModal('resourcepoolselector', ResourcepoolSelector, {
        props: {
          selectedResourcepools: this.resourcepool.sharedResourcepool.map(r => { return { id: r.id } })
        },
        events: {
          selectResourcepools: this.addResourcepools
        },
        handlers: {},
        width: 800
      })
    },
    addResourcepools (resourcepools) {
      if (resourcepools && resourcepools.length) {
        this.resourcepool.sharedResourcepool.push(...resourcepools)
      }
    },
    removeResourcepool(resourcepool) {
      this.resourcepool.sharedResourcepool = this.resourcepool.sharedResourcepool.filter(r => r.id !== resourcepool.id)
    },
  },
  watch: {
    selectable (newValue) {
      if (parseInt(newValue)) {
        this.resourcepool.seatallocation = 'balance'
        if (this.resourcepool.allocation !== 'priority') {
          this.resourcepool.allocation = 'random'
        }
      }
    },
    allocation (newValue) {
      if (newValue === 'all') {
        this.resourcepool.seatallocation = 'balance'
        this.resourcepool.selectable = '0'
      }
    }
  },
  created () {
    if (this.component && this.component.initData) {
      this.loadResourcepool(this.component.initData.resourcepoolId)
    }
  },
  async updated () {
    if (this.activeTab === 'resourcepools' && !this.isTopLevelResourcepool) {
      this.activeTab = 'general'
    }
    if (this.component && this.component.initData) {
      if (this.resourcepool && this.resourcepool.id && parseInt(this.resourcepool.id, 10) !== parseInt(this.component.initData.resourcepoolId, 10)) {
        try {
          await this.loadResourcepool(this.component.initData.resourcepoolId)
        } catch(e) {}
      }
    }
  },
  async mounted () {
    if(!this.events) {
      let events = {}
      events['resourcepoolUpdate'] = async (message) => {
        if (message && message.data && this.resourcepool && parseInt(message.data.id, 10) === parseInt(this.resourcepool.id, 10)) {
          if (!this.unsavedChanges) { // Only update if we haven't made any changes
            this.loadResourcepool(message.data.id)
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>

<style scoped>
.removeitem {
  cursor: pointer;
}
.well-info {
  background-color: #d9edf7;
}
.well-warning {
  background-color: #fcf8e3;
}
.well {
  margin-top: 20px;
}
.well h3 {
  margin-top: 11px;
}
</style>
